const asyncActionType = (type) => ({
  init: `${type}_INIT`,
  success: `${type}_SUCCESS`,
  failure: `${type}_FAILURE`,
});

export default asyncActionType;
